import IntegrationAmoCrmApi from '@/api/adminPanel/settings/IntegrationAmoCrm/IntegrationAmoCrmApi'
import { setAlertError } from '@/utils/store/alert'

const INTEGRATION_AMOCRM_ERRORS = {
  getToken: 'Не удалось получить токен AmoCrm',
  setToken: 'Не удалось сохранить токен AmoCrm'
}

export default {
  // Получение токена AmoCrm
  getToken: async () => {
    try {
      return await IntegrationAmoCrmApi.getToken()
    } catch (e) {
      await setAlertError(e, INTEGRATION_AMOCRM_ERRORS.getToken)
    }
  },

  // Установка токена AmoCrm
  // data: {
  //     "access_token": "...",
  //     "deadline": "2030-12-31"
  // }
  setToken: async (data) => {
    try {
      return await IntegrationAmoCrmApi.setToken(data)
    } catch (e) {
      await setAlertError(e, INTEGRATION_AMOCRM_ERRORS.setToken)
    }
  }
}
